import { OrganizationDevicesTableColumn, OrganizationUsersTableColumn } from './enums';

export const OrganizationDevicesTableColumns = [
  {
    column: OrganizationDevicesTableColumn.SERIAL_NUMBER,
    minWidth: (expanded: boolean) => (expanded ? 45 : 50),
  },
  {
    column: OrganizationDevicesTableColumn.PATIENT,
    minWidth: (expanded: boolean) => (expanded ? 45 : 50),
  },
  {
    column: OrganizationDevicesTableColumn.MENU,
    minWidth: (expanded: boolean) => (expanded ? 10 : 0),
  },
];

export const OrganizationUsersTableColumns = [
  {
    column: OrganizationUsersTableColumn.NAME,
    minWidth: (expanded: boolean) => (expanded ? 40 : 45),
  },
  {
    column: OrganizationUsersTableColumn.EMAIL,
    minWidth: (expanded: boolean) => (expanded ? 40 : 45),
  },
  {
    column: OrganizationUsersTableColumn.ROLE,
    minWidth: (expanded: boolean) => (expanded ? 10 : 10),
  },
  {
    column: OrganizationUsersTableColumn.MENU,
    minWidth: (expanded: boolean) => (expanded ? 10 : 0),
  },
];
